var _rect, _rect2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "url(#paint0_linear_34_18)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 3.75,
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3633 8.65425C18.3693 8.79675 18.3708 8.94375 18.3708 9.09075C18.3708 13.5383 15.0708 18.6668 9.03183 18.6668C7.17933 18.6668 5.45283 18.1088 3.99933 17.1548C4.25583 17.1863 4.51833 17.2013 4.78383 17.2013C6.32133 17.2013 7.73733 16.6628 8.86083 15.7598C7.42383 15.7343 6.21183 14.7608 5.79333 13.4243C5.99433 13.4633 6.20133 13.4843 6.41133 13.4843C6.71133 13.4843 7.00083 13.4438 7.27683 13.3658C5.77383 13.0568 4.64283 11.6963 4.64283 10.0643V10.0238C5.08533 10.2743 5.59233 10.4273 6.13083 10.4423C5.24883 9.83925 4.66983 8.80875 4.66983 7.64175C4.66983 7.02525 4.83183 6.44625 5.11383 5.94825C6.73383 7.98675 9.15183 9.32475 11.8803 9.46575C11.8248 9.21825 11.7963 8.96325 11.7963 8.69925C11.7963 6.84075 13.2663 5.33325 15.0768 5.33325C16.0218 5.33325 16.8753 5.74125 17.4723 6.39525C18.2223 6.24525 18.9243 5.96475 19.5588 5.57925C19.3128 6.36525 18.7938 7.02525 18.1143 7.44075C18.7788 7.36125 19.4118 7.17975 19.9998 6.91125C19.5618 7.58625 19.0053 8.17875 18.3633 8.65425Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_18",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a9349a9ba502b29fbfd84a2e2a6edca1.svg";
export { ForwardRef as ReactComponent };